import React from 'react';
import {
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Switch,
  Tooltip,
  makeStyles,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import Delete from '@material-ui/icons/Delete';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import '../listItem.component.scss';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { globalDateEntity } from '../../../constants/applicationConstants';
import { useHistory } from 'react-router-dom';
import { useStoreState } from 'easy-peasy';

const useStyles = makeStyles((theme) => ({
  icon: {
    color: theme.palette.primary.main,
  },
  rounded: {
    backgroundColor: theme.palette.grey[50],
    border: `1px solid #9D9D9D`,
    color: '#9D9D9D',
    width: '30px',
    height: '30px',
    cursor: 'pointer',
  },
  listItem: {
    color: '#434343',
    border: '1px solid #ededed',
    alignItems: 'center',
  },
}));

const ReportBuilderList = ({ entityData, handleInlineStatusChange }) => {
  const classes = useStyles();
  const history = useHistory();
  const loggedInUserInfo = useStoreState((state) => state.login.userInfo);

  const getDate = (execution_datetime) => {
    let date;
    if (execution_datetime) {
      date = execution_datetime.replace(/-/g, '/');
      date = moment
        .utc(date)
        .local()
        .format(globalDateEntity.dateTimeFormatWith24Hour);
    }
    return date;
  };

  return (
    <Grid container className={classes.listItem}>
      <Grid item xs={11}>
        <Grid container spacing={1} style={{ padding: '20px' }} alignItems='center'>
          <Grid item xs={12} className="textItemTitle">
            {entityData.title}
            <br />
          </Grid>

          <Grid item xs={2}>
            Version: {entityData.version}
          </Grid>
          <Grid item xs={2}>
            Owner: {entityData.username?.username || 'N/A'}
          </Grid>
          <Grid item sm={4}>
            Last Run Date: {getDate(entityData.execution_datetime) || 'N/A'}
          </Grid>
          <Grid item sm={2}>
            <FormControl component="fieldset">
              <FormGroup>
                <FormControlLabel
                  data-testid="current_status_lable"
                  control={
                    <Switch
                      color="primary"
                      name="visibility"
                      data-testid="visibility"
                      checked={
                        entityData.visibility == 'Private' ? false : true
                      }
                      onChange={(event) => handleInlineStatusChange({type: "statusChange", data: entityData, event})}
                      disabled={loggedInUserInfo.PK === entityData.user_id ? false : true}
                    />
                  }
                  label={entityData.visibility}
                  className="switchLabel"
                />
              </FormGroup>
            </FormControl>
          </Grid>
          <Grid item sm={2}>
            <Grid>
              <div style={{ display: 'flex' }}>
                <Tooltip title="Edit Report">
                  <IconButton
                    color="primary"
                    aria-label="Edit Report"
                    onClick={() => {
                      history.push('/reports/'+encodeURIComponent(entityData.PK))
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
                <Tooltip title="Execute Report">
                  <IconButton
                    color="primary"
                    aria-label="Execute Report"
                    onClick={() => {
                      handleInlineStatusChange({type:"execute", data: entityData.PK})
                    }}
                  >
                    <PlayCircleOutlineIcon />
                  </IconButton>
                </Tooltip>
                {entityData.last_generated_report != null ? (
                  <Link
                    href="#"
                    onClick={(event) =>
                      handleInlineStatusChange({type:"download", event, data: entityData.last_generated_report})
                    }
                  >
                    <Tooltip title="Download Report">
                      <IconButton color="primary" aria-label="Download Report">
                        <CloudDownloadIcon />
                      </IconButton>
                    </Tooltip>
                  </Link>
                ) : (
                  <IconButton
                    color="primary"
                    aria-label="Download Report"
                    disabled="true"
                  >
                    <CloudDownloadIcon />
                  </IconButton>
                )}
                {entityData.report_owner && (
                  <Tooltip title="Delete Report">
                    <IconButton
                      color="primary"
                      aria-label="Delete"
                      onClick={(event) => {
                        handleInlineStatusChange({type:"delete", data: entityData})
                      }}
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                )}
              </div>
            </Grid>
          </Grid>
          
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ReportBuilderList;
